import { CURRENT_PATHNAME_STORAGE_KEY, PREVIOUS_PATHNAME_STORAGE_KEY } from "../constants";

export const getLocalPreviousPathname = () => sessionStorage.getItem(PREVIOUS_PATHNAME_STORAGE_KEY) || "/";
export const getLocalCurrentPathname = () => sessionStorage.getItem(CURRENT_PATHNAME_STORAGE_KEY) || "/";

export function getJSON<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch (err) {
    console.warn("storage.getJSON failed", err);
    return null;
  }
}

export function setJSON(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.warn("storage.setJSON failed", err);
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.warn("storage.remove failed", err);
  }
}
